import { render, staticRenderFns } from "./UserSettingShippingAddress.vue?vue&type=template&id=36e0962c&scoped=true&"
import script from "./UserSettingShippingAddress.vue?vue&type=script&lang=js&"
export * from "./UserSettingShippingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0962c",
  null
  
)

export default component.exports